import { createSelector } from 'reselect'
import * as R from 'ramda'

const validationStateSelector = state => state.formValidation

const includeId = (id) => R.find(
  R.compose(
    R.contains(id),
    R.prop('elementIds')
  )
)

const getFirstFalseId = R.compose(
  R.prop(0),
  R.find(R.propEq(1, false)),
  R.toPairs
)

const showValidationSelector = id => createSelector(
  validationStateSelector,
  (ids) => R.not(ids[id])
)

const invalidCategorySelector = (categoryElementsSelector) => createSelector(
  validationStateSelector,
  categoryElementsSelector,
  (ids, idsToCategories) => {
    let categoryName = null
    let id = getFirstFalseId(ids)
    if (id) {
      const { category } = includeId(id)(idsToCategories)
      categoryName = category
    }

    return categoryName
  }
)

const validationElementCountSelector = createSelector(
  validationStateSelector,
  R.compose(
    R.prop('length'),
    R.keys
  )
)

export {
  invalidCategorySelector,
  validationStateSelector,
  showValidationSelector,
  validationElementCountSelector,
}
